import { router, useLocalSearchParams } from 'expo-router';
import { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import FormWrapper from '@/components/forms/FormWrapper';
import TotalGrantProgramForm from '@/components/forms/TotalGrantProgramForm';
import { TotalGrantProgramData } from '@/lib/validations/NpoOnboardingSchema';
import { safeJsonParse } from '@/utils/jsonParse';

const AddUpdateTotalGrantProgram = () => {
  const { totalGrantProgamJson, totalGrantProgamIndex } = useLocalSearchParams<{
    totalGrantProgamJson: string;
    totalGrantProgamIndex: string;
  }>();
  const [initialTotalGrantProgram, setInitialTotalGrantProgram] = useState<TotalGrantProgramData | undefined>(
    undefined
  );

  useEffect(() => {
    if (totalGrantProgamJson) {
      const parsedTotalGrantProgam = safeJsonParse<TotalGrantProgramData>(totalGrantProgamJson);
      if (parsedTotalGrantProgam) setInitialTotalGrantProgram(parsedTotalGrantProgam);
    }
  }, [totalGrantProgamJson]);

  return (
    <SafeAreaView style={styles.content} edges={['bottom']}>
      <FormWrapper scrollEnable={false}>
        <View style={styles.container}>
          <TotalGrantProgramForm
            initialData={initialTotalGrantProgram}
            showDoneButton
            onDone={(data) => {
              router.dismissTo({
                pathname: '/edit/npoTotalGrantsPrograms',
                params: {
                  totalGrantProgamJson: JSON.stringify(data),
                  totalGrantProgamIndex: totalGrantProgamIndex
                }
              });
            }}
          />
        </View>
      </FormWrapper>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  content: {
    flex: 1
  },

  container: {
    flex: 1
  }
});

export default AddUpdateTotalGrantProgram;
